export enum DriverScheduleUpdateTypeEnum {
  Supplier = 1,
  Engineius = 2,
  Juno = 3,
}
export const DriverScheduleUpdateTypeLabels = {
  [DriverScheduleUpdateTypeEnum.Supplier]: 'Supplier',
  [DriverScheduleUpdateTypeEnum.Engineius]: 'Engineius',
  [DriverScheduleUpdateTypeEnum.Juno]: 'Juno',
};
